// ─────────────────────────────────────────────────────────────────────────────
// File d'attente : au plus `max` tâches en parallèle, les suivantes attendent.
// Évite de saturer SSAS (ex. Top N Dashboard : un panneau = une requête MDX).
// Une tâche annulée pendant qu'elle attend est retirée sans être lancée.
// ─────────────────────────────────────────────────────────────────────────────

const abortError = (): Error => {
  const err = new Error("aborted");
  err.name = "AbortError";
  return err;
};

export function createLimiter(max: number) {
  let running = 0;
  const queue: Array<() => void> = [];

  const next = () => {
    if (running >= max) return;
    const start = queue.shift();
    if (start) start();
  };

  return function limit<T>(task: () => Promise<T>, signal?: AbortSignal): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      if (signal?.aborted) return reject(abortError());

      const start = () => {
        signal?.removeEventListener("abort", onAbort);
        running++;
        task()
          .then(resolve, reject)
          .finally(() => {
            running--;
            next();
          });
      };
      const onAbort = () => {
        const i = queue.indexOf(start);
        if (i >= 0) queue.splice(i, 1);
        reject(abortError());
      };

      signal?.addEventListener("abort", onAbort, { once: true });
      queue.push(start);
      next();
    });
  };
}
